import { de } from "./de";
import { en } from "./en";
import { fr } from "./fr";
const lang_config = {
  de,
  en,
  fr,
};

export default lang_config;
